import { compose, withHandlers } from 'recompose';
import { connect } from 'react-redux';

import NavBarView from './NavBarView';

export default compose(
  connect(
    state => ({
      token: state.auth.token,
    }),
  ),
  withHandlers({
    onClick: props => () => {
      console.log(props);
    },
  }),
)(NavBarView);
